import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1'}/users`;

type User = {
  _id: string;
  name: string;
  email: string;
  role: 'admin' | 'manager' | 'staff';
  isActive: boolean;
};

const StaffManagement = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [form, setForm] = useState<Partial<User & { password: string }>>({});
  const [editId, setEditId] = useState<string | null>(null);
  const token = localStorage.getItem('token');

  const headers = { Authorization: `Bearer ${token}` };

  const fetchUsers = async () => {
    try {
      const res = await axios.get(API, { headers });
      setUsers(res.data);
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      if (editId) {
        await axios.put(`${API}/${editId}`, form, { headers });
      } else {
        await axios.post(API, form, { headers });
      }
      setForm({});
      setEditId(null);
      fetchUsers();
    } catch (err) {
      console.error('Save error:', err);
      alert('Error saving user');
    }
  };

  const handleEdit = (user: User) => {
    setForm(user);
    setEditId(user._id);
  };

  const handleToggle = async (id: string) => {
    try {
      await axios.patch(`${API}/${id}/toggle`, {}, { headers });
      fetchUsers();
    } catch (err) {
      console.error('Toggle error:', err);
    }
  };

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-xl font-bold">Staff Management</h1>

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <input
            type="text"
            placeholder="Name"
            className="border p-2"
            value={form.name || ''}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required
          />
          <input
            type="email"
            placeholder="Email"
            className="border p-2"
            value={form.email || ''}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
          {!editId && (
            <input
              type="password"
              placeholder="Password"
              className="border p-2"
              value={form.password || ''}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required
            />
          )}
          <select
            className="border p-2"
            value={form.role || 'staff'}
            onChange={(e) =>
              setForm({ ...form, role: e.target.value as User['role'] })
            }
          >
            <option value="admin">Admin</option>
            <option value="manager">Manager</option>
            <option value="staff">Staff</option>
          </select>
        </div>
        <button className="bg-blue-600 text-white px-4 py-2 rounded">
          {editId ? 'Update Staff' : 'Add Staff'}
        </button>
      </form>

      {/* Table */}
      <table className="w-full border text-sm mt-6">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 border">Name</th>
            <th className="p-2 border">Email</th>
            <th className="p-2 border">Role</th>
            <th className="p-2 border">Status</th>
            <th className="p-2 border">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user._id}>
              <td className="p-2 border">{user.name}</td>
              <td className="p-2 border">{user.email}</td>
              <td className="p-2 border capitalize">{user.role}</td>
              <td className="p-2 border">
                {user.isActive ? 'Active' : 'Inactive'}
              </td>
              <td className="p-2 border space-x-2">
                <button
                  onClick={() => handleEdit(user)}
                  className="bg-yellow-500 text-white px-2 py-1 rounded"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleToggle(user._id)}
                  className="bg-red-600 text-white px-2 py-1 rounded"
                >
                  {user.isActive ? 'Deactivate' : 'Activate'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StaffManagement;


// import { useEffect, useState } from 'react';
// import api from '../services/api';
// import { useAuth } from '../context/AuthContext';

// interface User {
//   _id: string;
//   name: string;
//   email: string;
//   role: 'admin' | 'manager' | 'staff';
//   isActive: boolean;
// }

// const StaffManagement = () => {
//   const [users, setUsers] = useState<User[]>([]);
//   const [form, setForm] = useState<Partial<User & { password: string }>>({});
//   const [editId, setEditId] = useState<string | null>(null);

//   const token = localStorage.getItem('token');

//   const fetchUsers = async () => {
//     const res = await api.get('/users', {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     setUsers(res.data);
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();

//     try {
//       if (editId) {
//         await api.put(`/users/${editId}`, form, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//       } else {
//         await api.post('/users', form, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//       }

//       setForm({});
//       setEditId(null);
//       fetchUsers();
//     } catch (err) {
//       console.error(err);
//       alert('Error saving user');
//     }
//   };

//   const handleEdit = (user: User) => {
//     setForm(user);
//     setEditId(user._id);
//   };

//   const handleToggle = async (id: string) => {
//     await api.patch(`/users/${id}/toggle`, {}, {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     fetchUsers();
//   };

//   return (
//     <div className="space-y-6">
//       <h1 className="text-xl font-bold">Staff Management</h1>

//       {/* Form */}
//       <form onSubmit={handleSubmit} className="space-y-2">
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//           <input
//             className="border p-2"
//             placeholder="Name"
//             value={form.name || ''}
//             onChange={(e) => setForm({ ...form, name: e.target.value })}
//             required
//           />
//           <input
//             className="border p-2"
//             placeholder="Email"
//             value={form.email || ''}
//             onChange={(e) => setForm({ ...form, email: e.target.value })}
//             required
//           />
//           {!editId && (
//             <input
//               className="border p-2"
//               type="password"
//               placeholder="Password"
//               value={form.password || ''}
//               onChange={(e) => setForm({ ...form, password: e.target.value })}
//               required
//             />
//           )}
//           <select
//             className="border p-2"
//             value={form.role || 'staff'}
//             onChange={(e) => setForm({ ...form, role: e.target.value as any })}
//           >
//             <option value="admin">Admin</option>
//             <option value="manager">Manager</option>
//             <option value="staff">Staff</option>
//           </select>
//         </div>
//         <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
//           {editId ? 'Update User' : 'Add Staff'}
//         </button>
//       </form>

//       {/* Table */}
//       <table className="min-w-full border mt-6 text-sm">
//         <thead className="bg-gray-100">
//           <tr>
//             <th className="border p-2">Name</th>
//             <th className="border p-2">Email</th>
//             <th className="border p-2">Role</th>
//             <th className="border p-2">Status</th>
//             <th className="border p-2">Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {users.map((u) => (
//             <tr key={u._id}>
//               <td className="border p-2">{u.name}</td>
//               <td className="border p-2">{u.email}</td>
//               <td className="border p-2">{u.role}</td>
//               <td className="border p-2">
//                 {u.isActive ? 'Active' : 'Inactive'}
//               </td>
//               <td className="border p-2 space-x-2">
//                 <button
//                   onClick={() => handleEdit(u)}
//                   className="bg-yellow-500 text-white px-2 py-1 rounded"
//                 >
//                   Edit
//                 </button>
//                 <button
//                   onClick={() => handleToggle(u._id)}
//                   className="bg-red-500 text-white px-2 py-1 rounded"
//                 >
//                   {u.isActive ? 'Deactivate' : 'Activate'}
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default StaffManagement;

